import { Button } from "@mui/material";

type Props = {
	onNewProcess: () => void;
};

const NewProcessStatusBar = (props: Props) => {
	return (
		<div style={{ padding: "5px" }}>
			<Button variant="contained" color="primary" onClick={props.onNewProcess}>
				NEW PROCESS
			</Button>
		</div>
	);
};

export default NewProcessStatusBar;
